<template>
  <div class="mpsz-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            名片设置
          </div>
          <div class="card-content" v-loading="loading">
            <el-form ref="eForm" :model="eForm" :rules="eRules" label-width="100px">
              <el-form-item label="形象照" prop="img">
                <span style="color:#99a9bf;font-size: 12px;"><i class="el-icon-info"></i> 图片建议尺寸750*960px</span>
                <SingleImgCutting :key="imgKey" v-model="eForm.img" :oldurl="eForm.oldImg_url" :size="[200,256]"></SingleImgCutting>
              </el-form-item>
              <el-form-item label="性别" prop="sex">
                <el-radio v-model="eForm.sex" :label="1">男</el-radio>
                <el-radio v-model="eForm.sex" :label="0">女</el-radio>
              </el-form-item>
              <el-form-item label="姓名" prop="name" >
                <el-input v-model="eForm.name" maxlength="20" placeholder="请编辑姓名" show-word-limit>
                </el-input>
              </el-form-item>
              <el-form-item label="职位" prop="position" >
                <el-input v-model="eForm.position" maxlength="20" placeholder="请编辑职位" show-word-limit>
                </el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone" >
                <el-input  v-model="eForm.phone"  maxlength="11" placeholder="请编辑电话"  show-word-limit>
                </el-input>
              </el-form-item>
              <el-form-item label="微信" prop="vx" >
                <el-input v-model="eForm.vx" maxlength="20" placeholder="请编辑微信" show-word-limit>
                </el-input>
              </el-form-item>
              <el-form-item label="个人标签" prop="tag">
                <el-tag
                  :key="tag"
                  v-for="tag in eForm.dynamicTags"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)">
                  {{tag}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="small"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新建标签</el-button>
              </el-form-item>
              <el-form-item label="个人简介" prop="introduce" >
                <el-input type="textarea" v-model="eForm.introduce" maxlength="500" placeholder="" show-word-limit>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="eidtLoading" @click="submitForm('eForm')">{{eForm.cardid===null?'添加名片':'修改名片'}}</el-button>
                <el-popover
                  v-if="eForm.cardid!==null&&eForm.cardid!==''&&eForm.cardid!==undefined"
                  placement="top"
                  width="174"
                  trigger="click">
                  <div style="text-align: center">
                    <el-image :src="smallProgramCode!==null&&smallProgramCode!==undefined&&smallProgramCode!==''?smallProgramCode:qcode_loading" style="height: 150px;width: 150px"></el-image>
                  </div>
                  <el-button slot="reference" @click="getSmallProgramCode">生成小程序码</el-button>
                </el-popover>
                <el-button v-if="eForm.cardid!==null&&eForm.cardid!==''&&eForm.cardid!==undefined" icon="el-icon-picture-outline" @click="operViewMaterial">素材生成</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="素材生成"
      :visible.sync="viewMaterial"
      width="700px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="mForm" :model="mForm" :rules="mRules" size="small" label-width="75px">
        <el-form-item label="显示" prop="radio">
          <el-radio v-model="mForm.radio" :label="1">顶部</el-radio>
          <el-radio v-model="mForm.radio" :label="2">底部</el-radio>
        </el-form-item>
        <el-form-item label="底图" prop="img">
          <span style="color:#99a9bf;font-size: 12px;"><i class="el-icon-info"></i> 图片高度不可低于200像素</span>
          <el-upload
            class="singleimg-uploader"
            :action="uploadFile"
            :show-file-list="false"
            accept=".webp,.bmp,.pcx,.tif,.gif,.jpeg,.tag,.exif,.fpx,.svg,.png,.ico,.jpg"
            :on-success="handleMaterialSuccess"
            :on-error="handleMaterialError">
            <div v-if="mForm.img!==null&&mForm.img!==undefined" style="position: relative">
              <img :src="mForm.img.imgurl" class="materialimg">
            </div>
            <i v-else class="el-icon-plus singleimg-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="primary" :loading="mLoading" @click="createTheMaterial('mForm')">生成并预览</el-button>
          <el-button @click="viewMaterial=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="素材预览"
      :visible.sync="viewtempMaterial"
      width="500px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-alert style="margin-bottom: 10px" title="右键图片另存为即可保存图片" type="success" show-icon></el-alert>
      <img :src="murldata.url" style="width: 100%;border: 1px solid #f3f6f9;">
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { selectUseridCallingCard, editCallingCard, getSmallProgramCode, createTheMaterial } from '@/api/zsxcx'
import SingleImgCutting from '@/components/upload/SingleImgCutting'
import { validatePhoneNumber } from '@/utils/validate'
import qcode_loading from '@/assets/qcode_loading.jpg'
export default {
  name: 'mpsz',
  components: { SingleImgCutting },
  computed: {
    user: getUser
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的电话号码'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      qcode_loading: qcode_loading,
      eidtLoading: false,
      eForm: {
        cardid: null,
        userid: null,
        img: null,
        oldImg_url: '',
        name: '',
        sex: 1,
        position: '',
        phone: '',
        vx: '',
        introduce: '',
        dynamicTags: []
      },
      inputVisible: false,
      inputValue: '',
      imgKey: '',
      eRules: {
        img: [{ required: true, message: '请上传形象照', trigger: 'change' }],
        sex: [{ required: true, message: '性别不能为空', trigger: 'change' }],
        name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        position: [{ required: true, message: '职位不能为空', trigger: 'blur' }],
        phone: [{ required: true, validator: checkPhone, trigger: 'blur' }],
        vx: [{ required: true, message: '微信不能为空', trigger: 'blur' }],
        introduce: [{ required: true, message: '请填写个人简介', trigger: 'blur' }]
      },
      uploadFile: process.env.VUE_APP_BASE_API + '/fileUpload/uploadImg',
      smallProgramCode: qcode_loading,
      smallShow: false,
      viewMaterial: false,
      mForm: {
        img: null,
        radio: 1
      },
      mRules: {
        img: [{ required: true, message: '请上传素材底图', trigger: 'change' }],
        radio: [{ required: true, message: '请选择信息显示位置', trigger: 'change' }]
      },
      mLoading: false,
      murldata: {},
      viewtempMaterial: false
    }
  },
  created() {
    this.selectUseridCallingCard()
  },
  methods: {
    createTheMaterial(formName) {
      if (!this.mLoading) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.mLoading = true
            const data = {
              imgid: this.mForm.img.imgid,
              userid: this.user.dUserid,
              radio: this.mForm.radio
            }
            createTheMaterial(data).then(response => {
              this.murldata = response.data
              this.viewtempMaterial = true
              this.mLoading = false
            }).catch(() => {
              this.mLoading = false
            })
          }
        })
      }
    },
    operViewMaterial() {
      this.mForm = {
        img: null,
        radio: 1
      }
      this.mLoading = false
      this.murldata = {}
      this.viewMaterial = true
    },
    handleMaterialSuccess(res, file) {
      if (res.data.dHeight >= 200) {
        this.mForm.img = { imgid: res.data.dImgid, imgurl: res.data.img_url }
      } else {
        this.$message.error('请上传高度高于200像素的素材图片')
      }
    },
    handleMaterialError() {
      this.$message({
        type: 'error',
        message: '图片上传失败，请稍后重试'
      })
    },
    getSmallProgramCode() {
      const data = {
        scene: 'staffid=' + this.user.dUserid,
        page: 'pages/businesscard/businesscard'
      }
      getSmallProgramCode(data).then(response => {
        this.smallProgramCode = response.msg
        this.smallShow = true
      })
    },
    selectUseridCallingCard() {
      this.loading = true
      const data = {
        userid: this.user.dUserid
      }
      selectUseridCallingCard(data).then(response => {
        this.imgKey = new Date().getTime().toString()
        if (response.data !== null) {
          var row = response.data
          this.eForm.cardid = row.cardid
          this.eForm.userid = row.userid
          this.eForm.img = { imgid: row.imgid, img_url: row.img_url }
          this.eForm.oldImg_url = row.img_url
          this.eForm.sex = row.sex
          this.eForm.name = row.name
          this.eForm.position = row.position
          this.eForm.phone = row.phone
          this.eForm.vx = row.vx
          this.eForm.introduce = row.introduce
          this.eForm.dynamicTags = row.tagList
          let dynamicTags = []
          if (row.tagList.length < 1) {
            dynamicTags = []
          } else {
            for (let i = 0; i < row.tagList.length; i++) {
              dynamicTags.push(row.tagList[i].content)
            }
          }
          this.eForm.dynamicTags = dynamicTags
        }
        this.loading = false
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.eidtLoading = true
          this.$confirm('此操作将提交名片信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const data = {
              cardid: this.eForm.cardid,
              userid: this.user.dUserid,
              role: this.user.role,
              groupid: this.user.dGroupid,
              imgid: this.eForm.img.imgid,
              sex: this.eForm.sex,
              name: this.eForm.name,
              position: this.eForm.position,
              phone: this.eForm.phone,
              vx: this.eForm.vx,
              introduce: this.eForm.introduce,
              tagList: this.eForm.dynamicTags.join(',')
            }
            editCallingCard(data).then(response => {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.eidtLoading = false
              this.selectUseridCallingCard()
            }).catch(() => {
              this.eidtLoading = false
            })
          }).catch(() => {
            this.eidtLoading = false
          })
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleClose(tag) {
      this.eForm.dynamicTags.splice(this.eForm.dynamicTags.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue.length > 20) {
        this.$message({
          message: '标签不能超过20长度',
          type: 'error'
        })
      } else {
        if (inputValue) {
          let arr = this.eForm.dynamicTags
          for (let i = 0; i < arr.length; i++) {
            if (arr[i] === inputValue) {
              this.$message({
                message: '标签不能重复',
                type: 'error'
              })
              return
            }
          }
          this.eForm.dynamicTags.push(inputValue)
        }
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.cropper-content {
  .cropper {
    width: auto;
    height: 300px;
  }
}
.materialimg{
  max-width: 250px;
  max-height: 300px;
  display: block;
}
</style>
